import type { FC } from 'react';
import React from 'react';
// TODO: https://jira.moscow.alfaintra.net/browse/ALFABANKRU-83779
// eslint-disable-next-line package-imports/no-core-components-imports
import { Plate } from '@alfalab/core-components-plate';
// TODO: https://jira.moscow.alfaintra.net/browse/ALFABANKRU-83779
// eslint-disable-next-line package-imports/no-core-components-imports
import { Badge } from '@alfalab/core-components-badge';
import { InformationCircleMIcon } from '@alfalab/icons-glyph/InformationCircleMIcon';
import { defaultNotFoundFeedBlockSettings } from '@alfa-bank/site-invest-emitents-common/config';

import type { TNotFoundAsset } from './models';

export const NotFoundAssets: FC<TNotFoundAsset> = ({
    title = defaultNotFoundFeedBlockSettings.title,
    description = defaultNotFoundFeedBlockSettings.description,
    Layout,
}) => (
    <Layout dataTestId="not-found-section">
        <Plate
            leftAddons={
                <Badge content={<InformationCircleMIcon />} iconColor="secondary" view="icon" />
            }
            limitContentWidth={false}
            title={title}
        >
            {description}
        </Plate>
    </Layout>
);
